// extracted by mini-css-extract-plugin
export default {"order-item-row":"ZXtoBMNK","orderItemRow":"ZXtoBMNK"};